export interface VirtualPaddingProps {
    show: boolean;
    height: number;
}

export const VirtualPadding: React.FC<VirtualPaddingProps> = ({ show, height }) =>
    show && height > 0 ? <div style={{ height }} /> : null;
